import React, {useEffect, useState} from 'react';
import {CircleLoading, Label, NullMsgLabel, Popover, Section} from "../../../../common/fusion-ui";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    formatDate,
    generateOrdinalIndicator,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue,
    limitStringWords
} from "../../../../common/fusion-ui/utils/ReactUtils";
import {printError, printLog, sendRequest} from "../../../utils/AppUtils";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {Constants, CssVariant, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {Keys, ReqUrls} from "../../../config/AppConfig";
import useScreenSize from "../../../../common/fusion-ui/hook/useScreenSize";
import {useReduxPersistSessionData} from "../../../hook/useReduxPersistSessionData";
import {useConfig} from "../../../context/ConfigProvider";
import {AnimationType, FramerAnimator} from "../../../../common/fusion-ui/animation/FramerAnimator";

const DashboardCalendar = React.memo(({
                                          className = "",
                                          style = {}
                                      }) => {
    const TAG = "DashboardCalendar";

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isScreenUpSm} = useScreenSize();
    const {isConfigTrue, getConfig} = useConfig();

    const animator = new FramerAnimator();

    // const PANEL_HEIGHT = '41vh';
    const PANEL_HEIGHT = 'auto';
    const DATE_FORMAT = Constants.YYYY_MM_DD_DASH;
    const MN_FORMAT = "MM";
    const YR_FORMAT = "YYYY";
    const LINK_CHAR_LIMIT = isScreenUpSm ? 50 : 30;
    const EvtKeys = {
        id: 'id',
        module: 'module',
        title: 'title',
        link: 'link',
        date: 'date',
    };

    const Fields = {
        eventList_Session: 'eventList_Session',
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',
    };
    const [fieldsData, setFieldsData] = useState({});

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [nextEvent, setNextEvent] = useState({});
    const [mnYrChangeData, setMnYrChangeData] = useState({month: null, year: null, date: null, title: getDefDateTitle(selectedDate)});
    // const [events, setEvents] = useState(DashboardCalendar_Data);

    const {sessionData, updateSessionStoreFieldValue} = useReduxPersistSessionData({
        keys: [Fields.eventList_Session],
    });

    useEffect(() => {
        fetchEventsData();
    }, [sessionData]);
    return (<>
            {animator.setAnimationType(AnimationType.SLIDE_LEFT).render(
                <div
                    className={` ${className} ${isScreenUpSm ? 'mt-3' : ''}`}
                    style={{...style}}>
                    <Section className={'m-0 p-0'} borderless={true} shadowVariant={''}
                             style={{boxShadow: theme.boxShadowMdSm, height: PANEL_HEIGHT}}>
                        <div>
                            <div>
                                {/*calendar*/}
                                <div className={`select-none p-2`}>
                                    <Calendar
                                        className={'border-none w-100 td-none'}
                                        value={selectedDate}
                                        onClickDay={(date) => {
                                            setSelectedDate(date);
                                            setMnYrChangeData({
                                                month: null,
                                                year: null,
                                                date: null,
                                                title: getDefDateTitle(date)
                                            });
                                        }}
                                        onActiveStartDateChange={(args) => {
                                            const date = formatDate(args.activeStartDate.toDateString(), DATE_FORMAT);
                                            const month = formatDate(date, MN_FORMAT);
                                            const year = formatDate(date, YR_FORMAT);
                                            // log('Calendar.onActiveStartDateChange.args:', args, '\ndate:', date, '\nmonth:', month, '\nyear:', year);
                                            // setMnYrChangeData({month: month, year: year});

                                            let mn = null;
                                            let yr = null;
                                            let title = '';
                                            if (args.action == 'prev' || args.action == 'next') {
                                                //prev-month
                                                mn = month;
                                                title = `${formatDate(date, "MMMM")} Events:`;
                                            } else if (args.action == 'prev2' || args.action == 'next2') {
                                                //prev-year
                                                yr = year;
                                                title = `${year} Events:`;
                                            }
                                            setMnYrChangeData({month: mn, year: yr, date: date, title: title});
                                            setSelectedDate(null);
                                        }}
                                        tileClassName={(args) => {
                                            // log('calendar.tileClassName.args:', args);
                                            // return (formatDate(args, DATE_FORMAT) == formatDate(new Date(), DATE_FORMAT)) ? 'bg-success' : "bg-info"
                                            try {
                                                // return (getEventList().some(event => formatDate(event[EvtKeys.date], DATE_FORMAT) == formatDate(args.date.toDateString(), DATE_FORMAT))) ? 'event-found' : ''
                                                return `${(getEventList().some(event => formatDate(event[EvtKeys.date], DATE_FORMAT) == formatDate(args.date.toDateString(), DATE_FORMAT))) ? 'event-found' : ''} ${formatDate(args.date.toDateString(), DATE_FORMAT) == formatDate(new Date(), DATE_FORMAT) ? 'today' : ''}`;
                                                //event-found: a custom-class in style-css
                                            } catch (error) {
                                                // logErr('calendar.tileClassName.args:',error);
                                            }
                                            return '';
                                        }}
                                        // tileClassName={"bg-info"}
                                    />
                                </div>

                                {/*events panel*/}
                                <div>
                                    <div className={`my-2`}>
                                        {/*heading*/}
                                        <div className={'w-100 d-flex jc-center px-2'}>
                                            <Label className={'m-0 p-0 fw-bold text-nowrap'} textAt={'center'} color={theme.text}>
                                                {canShowNextEvent()
                                                    ? <span>Next Event:&nbsp;</span>
                                                    : <span>
                                                    {mnYrChangeData.title}
                                                </span>}
                                            </Label>
                                        </div>

                                        {/*list-loader*/}
                                        {isFieldTrue(Fields.isDataLoading) && <CircleLoading wrapperClassName={'mt-2'} borderWidth={'3px'} size={'28px'}/>}

                                        {/*event-list*/}
                                        {(!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound))
                                            ? <div className={`mt-1 px-2 pb-2 overflow-y-auto`}
                                                   style={{color: theme.text, maxHeight: '140px'}}>
                                                {canShowNextEvent()
                                                    ? <div>
                                                        {createEventLink(nextEvent, 0, true)}
                                                    </div>
                                                    : <div>
                                                        {checkNullArr(getEventsToRender())
                                                            ? getEventsToRender().map((event, index) => {
                                                                return <div key={index + event[EvtKeys.title]}
                                                                            className={"mb-1 pb-1 px-2"}>
                                                                    {createEventLink(event, index, (checkNullStr(mnYrChangeData.month) || checkNullStr(mnYrChangeData.year)))}
                                                                </div>
                                                            })
                                                            : <NullMsgLabel className={'mt-n1 fw-semi-bold'} color={theme.text50}>
                                                                No schedule for this date.
                                                            </NullMsgLabel>
                                                        }
                                                    </div>}
                                            </div>
                                            : (!isFieldTrue(Fields.isDataLoading) &&
                                                <NullMsgLabel className={'fw-semi-bold'} color={theme.text50}>
                                                    {getField(Fields.dataLoadingMsg)}
                                                </NullMsgLabel>)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Section>
                </div>
            )}
        </>
    );

    function createEventLink(event, index, showDate = false) {
        return <div className={'px-2 text-wraptext-breakword-wrap d-flexx fd-row'}
                    style={{lineHeight: 1.3, color: theme.text}}>
            {/*<span>event: {jsonToStr(event)}</span>*/}
            <span style={{color: theme.text70}}>{index + 1}.&nbsp;</span>
            <span className={'d-flexx fd-row'}>
                <Popover title={(event[EvtKeys.title] + '').length > LINK_CHAR_LIMIT ? event[EvtKeys.title] : ''}>
                    <a className={'m-0 p-0 text-wrap text-break word-wrap footer-link'}
                       href={event[EvtKeys.link]}
                       rel="noreferrer"
                       target={'_blank'}>
                    {limitStringWords(event[EvtKeys.title], LINK_CHAR_LIMIT, '', '...')}
                </a>
                </Popover>
                {showDate && <span className={'fw-semi-bold'}>&nbsp;({formatDate(event[EvtKeys.date], Constants.DD_MMM_YYYY_DASH)})</span>}
                <span className={'text-nowrap mt-1'}>&nbsp;&nbsp;
                    <span className={'d-flexx w-auto'}>
                        <span className={'rounded-10 px-2 py-1 text-center-force fs-md-sm fw-semi-bold'}
                              style={{backgroundColor: theme.text10, color: theme.text}}>
                            {event[EvtKeys.module]}
                        </span>
                    </span>
                </span>
            </span>
        </div>;
    }

    function getDefDateTitle(date) {
        return <span>
            <span>{"Event(s) on"}&nbsp;</span>
            <span>{formatDate(date, 'DD')}</span>
            <span><sup>{generateOrdinalIndicator(formatDate(date, 'DD'))}</sup> </span>
            <span>{formatDate(date, 'MMM')}</span>
        </span>
    }

    function canShowNextEvent() {
        return checkNullJson(nextEvent) && formatDate(selectedDate, DATE_FORMAT) == formatDate(new Date(), DATE_FORMAT);
    }

    function getEventsToRender() {
        let list = [];
        // log('getEventsToRender.mnYrChangeData:', mnYrChangeData);
        if (checkNullArr(getEventList())) {
            if (checkNullStr(selectedDate)) {
                list = getEventList().filter(item => formatDate(item[EvtKeys.date], DATE_FORMAT) == formatDate(selectedDate, DATE_FORMAT));
            } else if (checkNullJson(mnYrChangeData)) {
                if (checkNullStr(mnYrChangeData.month)) {
                    const format = `${MN_FORMAT}-${YR_FORMAT}`;
                    list = getEventList().filter(item => formatDate(item[EvtKeys.date], format) == formatDate(mnYrChangeData.date, format));
                } else if (checkNullStr(mnYrChangeData.year)) {
                    list = getEventList().filter(item => formatDate(item[EvtKeys.date], YR_FORMAT) == formatDate(mnYrChangeData.date, YR_FORMAT));
                }
            }
        }
        return list;
    }

    function getEventList() {
        // return events;
        return checkNullArr(getJsonValue(sessionData, Fields.eventList_Session)) ? getJsonValue(sessionData, Fields.eventList_Session) : [];
    }

    async function fetchEventsData(checkBefore = true) {
        const fun = 'fetchEventsData:';
        // log(fun, 'getEventList:', getEventList());
        if ((!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) && (isConfigTrue(Keys.config_showCalendar) && isConfigTrue(Keys.config_showHomeRightPanels))) {
            updateField(Fields.isDataFetched, true);
            // setEvents([]);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, true);
            updateField(Fields.dataLoadingMsg, "");

            //send-request
            const REQUEST_OPTIONS = {};
            try {
                // setEvents(DashboardCalendar_Data);
                // updateField(Fields.isDataFound, true);
                // updateField(Fields.isDataLoading, false);
                const sessionEventsAvail = checkNullArr(getJsonValue(sessionData, Fields.eventList_Session));
                if (sessionEventsAvail) {
                    updateField(Fields.isDataFound, true);
                    updateField(Fields.isDataLoading, false);
                } else {
                    sendRequest({
                        reqUrl: ReqUrls.dashCalendar__fetchEvents,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const eventList = getJsonValueFromNestedKeys(fetchedData, ['data', 'eventList'], []);
                            const nextEvent = getJsonValueFromNestedKeys(fetchedData, ['data', 'nextEvent'], {});
                            const success = isJsonValueTrue(fetchedData, 'success');
                            const message = getJsonValue(fetchedData, 'message');

                            updateField(Fields.isDataFound, success);
                            // setEvents(DashboardCalendar_Data);
                            if (success) {
                                // toast(message, CssVariant.success)
                                // setEvents(eventList);
                                updateSessionStoreFieldValue(Fields.eventList_Session, eventList);
                                setNextEvent(nextEvent);
                                updateField(Fields.isDataLoading, false);
                            } else {
                                toast(message, CssVariant.danger)
                                updateField(Fields.dataLoadingMsg, message);
                                updateField(Fields.isDataLoading, false);
                            }
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            toast("Couldn't load events, please refresh again!", CssVariant.danger)
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                }
            } catch (error) {
                logErr(fun, error);
                toast("Couldn't load events, please refresh again!", CssVariant.danger)
                updateField(Fields.dataLoadingMsg, Messages.fetchError);
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, false);
            }
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
export default DashboardCalendar;
